import Heading from '../../components/Heading'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import IconButton from '../../components/IconButton'
import { useFetchSingle } from '../../hooks/useFetchSingle'
import { ApiRoutes } from '../../services/ApiService'
import { Order } from '../../types/Order'
import FulfillmentDetail from './FulfillmentDetail'
import Card from '../../components/Card'

const FulfillmentOrder: React.FC = () => {
    const { t } = useTranslation(['fulfillment'])
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()

    const { data: order, fetch: fetchOrder } = useFetchSingle<Order>(
        ApiRoutes.ORDERS
    )

    useEffect(() => {
        if (id) fetchOrder(id)
    }, [id, fetchOrder])

    return (
        <div>
            <Heading level={2} classes={'zr-mb-4'}>
                {t('order.heading')} #{id}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate(`/fulfillment`)}
            >
                {t('detail.back')}
            </IconButton>
            {order && (
                <>
                    <Card
                        classes={'zr-my-4'}
                        style={{ background: '#FFCC0015' }}
                    >
                        <Heading level={3} classes={'zr-mb-4'}>
                            {t('order.subheading')}
                        </Heading>
                        <div className={'zr-d-flex zr-flex-column'}>
                            <div>
                                {t('order.customer')}:{' '}
                                {order.customer.firstname}{' '}
                                {order.customer.lastname}
                            </div>
                            <div>
                                {t('order.date')}: {order.datetime}
                            </div>
                            <div>
                                {t('order.status')}: {order.status}
                            </div>
                            <div>
                                {t('order.customization_count')}:{' '}
                                {order.customizations.length}
                            </div>
                        </div>
                    </Card>
                    {order.customizations.map((customization) => (
                        <FulfillmentDetail
                            key={customization.id}
                            customization_id={customization.id}
                        />
                    ))}
                </>
            )}
        </div>
    )
}

export default FulfillmentOrder
